
(function(){
  'use strict';
  var RE=/^\s*€\s*([0-9][0-9\s.,]*)\s*$/;
  function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}

  /* Part de remise revenant à chaque ligne.
     1) allocations réelles si Shopify en fournit (remise de niveau ligne) ;
     2) sinon répartition au prorata de la remise de commande, le reste d'arrondi
        étant reporté sur la dernière ligne pour tomber juste au centime. */
  /* 01/09 - CORRECTION DU DOUBLE COMPTAGE.
     Avant : on repartissait `cart.total_discount` sur les lignes, puis on le resoustrayait
     de `final_line_price`. Or `final_line_price` deduit DEJA les remises de LIGNE
     (classe produit, comme les packs). La remise etait donc comptee deux fois :
     279,98 € affichait « Économisez 55,98 € » au lieu de 27,99 €, et 224,00 € au lieu de 251,99 €,
     alors que le bouton Commander, lui, affichait le bon total. D ou l incoherence.

     Maintenant : on calcule ce qui reste VRAIMENT a deduire, c est-a-dire la seule remise de
     COMMANDE (le code promo), en retirant du total ce que les lignes ont deja absorbe.
     Ce calcul ne depend pas de `discount_allocations`, que Shopify ne remplit pas toujours. */
  function shares(cart){
    var items = cart.items || [];
    if (!items.length) return [];
    var sommeAvant = 0, sommeApres = 0;
    items.forEach(function(it){
      sommeAvant += it.original_line_price;
      sommeApres += it.final_line_price;
    });
    var dejaDeduit = sommeAvant - sommeApres;              /* remises de ligne */
    var reste = (cart.total_discount || 0) - dejaDeduit;   /* remise de commande */
    if (reste <= 0 || sommeApres <= 0) return items.map(function(){ return 0; });
    var used = 0;
    return items.map(function(it, i){
      if (i === items.length - 1) return reste - used;
      var part = Math.round(reste * it.final_line_price / sommeApres);
      used += part;
      return part;
    });
  }

  function renderLines(cart){
    var rows=document.querySelectorAll('#mzc-drawer .mzc-item[data-key]');
    if(!rows.length)return;
    var parts=shares(cart);
    var byKey={};
    (cart.items||[]).forEach(function(it,i){byKey[it.key]={item:it,share:parts[i]||0};});

    rows.forEach(function(row){
      var rec=byKey[row.getAttribute('data-key')];
      if(!rec)return;
      var it=rec.item, share=rec.share;
      var info=row.querySelector('.mzc-item-info')||row;

      var host=row.querySelector('.alm-unit');
      if(!host){host=document.createElement('div');host.className='alm-unit';info.appendChild(host);}
      var now=host.querySelector('.alm-line-now');
      if(!now){now=document.createElement('span');now.className='alm-line-now';host.appendChild(now);}
      var was=host.querySelector('.alm-line-was');
      var save=row.querySelector('.alm-save');

      /* 01/09 - CHOIX DE LANCELOT : la ligne d article n affiche QUE la remise du produit
         (les packs). La remise de COMMANDE (le code promo) ne touche pas au prix de la ligne,
         elle ne fait baisser que le total du bouton Commander. Chaque remise reste ainsi a
         son niveau, et le client voit clairement d ou vient chaque baisse.
         `share` n est donc plus soustrait ici. */
      var paid=it.final_line_price;
      var full=it.original_line_price;
      var saved=full-paid;

      var nowTxt=money(paid);
      if(now.textContent!==nowTxt)now.textContent=nowTxt;

      if(saved>0){
        row.classList.add('mzc-item--promo');
        if(!was){was=document.createElement('span');was.className='alm-line-was';host.appendChild(was);}
        var wasTxt=money(full);
        if(was.textContent!==wasTxt)was.textContent=wasTxt;
        if(!save){save=document.createElement('div');save.className='alm-save';info.appendChild(save);}
        var saveTxt='Économisez '+money(saved);
        if(save.textContent!==saveTxt)save.textContent=saveTxt;
      }else{
        row.classList.remove('mzc-item--promo');
        if(was)was.remove();
        if(save)save.remove();
      }
    });
  }

  function fixMoney(){
    document.querySelectorAll('#mzc-drawer .mzc-upsell-price, #mzc-drawer .mzc-empty-row-price').forEach(function(el){
      var m=RE.exec(el.textContent||'');
      if(m)el.textContent=m[1].trim()+' €';
    });
  }

  /* ══════════════════════════════════════════════════════════════════════════
     2026-08-25 — FIN DU CLIGNOTEMENT DU TIROIR (defaut remonte par Lancelot :
     « le panier saute », « le prix des cartes saute »).

     CE QUI SE PASSAIT, mesure au navigateur : a l'ouverture du tiroir, le
     contenu de #mzc-body etait reconstruit CINQ FOIS en 3,3 secondes. Le texte
     passait de 815 a 700 caracteres puis remontait par paliers, et le nombre de
     prix enrichis oscillait 2 -> 0 -> 2 -> 0 -> 2 -> 4.

     POURQUOI : six MutationObserver observent le tiroir, et CHACUN ecrit dans
     ce qu'il observe, sans jamais se deconnecter pendant son ecriture. Chaque
     ecriture reveille donc les cinq autres. Celui de ce fichier etait le plus
     couteux des six : son rappel declenchait un fetch('/cart.js') ENTIER a
     chaque tour, si bien que la cascade mettait un aller-retour reseau a
     converger — d'ou les 3,3 secondes, et le clignotement bien visible.
     La cascade finissait par s'arreter (les fonctions sont idempotentes), mais
     apres cinq allers-retours.

     TROIS VERROUS POSES ICI :
       1. EMPREINTE — on calcule une signature du panier (cle + quantite + prix
          de chaque ligne, remise, total). Si elle n'a pas bouge ET que la
          decoration est deja en place, on ne touche a rien. Supprime la quasi-
          totalite des ecritures inutiles.
       2. ON NE SE RE-DECLENCHE PAS SOI-MEME — apres nos propres ecritures on
          appelle obs.takeRecords(), qui vide la file des mutations que nous
          venons de provoquer SANS cesser d'ecouter. (Premiere version : un
          disconnect() suivi d'un observe() differe. Mauvaise idee — pendant
          cette fenetre les mutations des AUTRES scripts etaient perdues, et le
          tiroir restait sans prix apres un changement de quantite.)
       3. VERROU DE REQUETE EN VOL — un seul /cart.js a la fois. Si une mutation
          arrive pendant la requete, on la memorise (again) et on rejoue UNE
          fois a la fin, au lieu d'empiler cinq requetes.

     Les evenements panier explicites (cart:add, cart:updated…) remettent
     l'empreinte a zero : une vraie modification du panier est toujours prise en
     compte, seuls les faux-positifs sont filtres.
     POUR ANNULER : restaurer assets/bak-20260825-almea-panier-nautiya-patch.txt
     ══════════════════════════════════════════════════════════════════════════ */
  var obs=null, busy=false, again=false, lastSig='', filets=0;

  function signature(cart){
    return (cart.items||[]).map(function(it){
      return it.key+':'+it.quantity+':'+it.final_line_price+':'+it.original_line_price;
    }).join('|')+'#'+(cart.total_discount||0)+'#'+cart.total_price;
  }

  /* La decoration est-elle deja posee sur TOUTES les lignes ?
     Indispensable : quand z-paniermasazen refait body.innerHTML, le panier n'a
     pas change (meme signature) mais la decoration a ete rasee — il faut donc
     la reposer malgre l'empreinte identique. */
  /* 03/09 — PANIER VIDE = DECORATION EN PLACE. Avant, cette fonction exigeait
     au moins une ligne : avec un panier vide elle repondait toujours « non », le
     filet de 400 ms relancait tick(), tick() refaisait fetch('/cart.js')… a
     l'infini, toutes les 0,5 s, pour CHAQUE visiteur au panier vide (mesure :
     300 requetes /cart.js en deux minutes sur une fiche produit). */
  function decorationEnPlace(){
    var lignes=document.querySelectorAll('#mzc-drawer .mzc-item[data-key]');
    var decorees=document.querySelectorAll('#mzc-drawer .mzc-item[data-key] .alm-line-now');
    var cta=document.querySelector('#mzc-drawer .mzc-checkout-btn .alm-cta-label');
    var btn=document.querySelector('#mzc-drawer .mzc-checkout-btn');
    if(!lignes.length) return !btn || !!cta;
    return lignes.length===decorees.length && !!cta;
  }

  function appliquer(drawer,cart){
    var empty=!cart.item_count;
    drawer.classList.toggle('alm-cart-empty',empty);
    renderLines(cart);
    var btn=drawer.querySelector('.mzc-checkout-btn');
    if(!btn)return;
    var el=btn.querySelector('.alm-cta-label');
    if(!el){el=document.createElement('span');el.className='alm-cta-label';btn.appendChild(el);}
    var label=empty?'Commander':('Commander · '+money(cart.total_price));
    if(el.textContent!==label)el.textContent=label;
    var was=btn.querySelector('.alm-cta-was');
    var before=cart.items_subtotal_price||0;
    if(!empty&&(cart.total_discount||0)>0&&before>cart.total_price){
      if(!was){was=document.createElement('span');was.className='alm-cta-was';btn.appendChild(was);}
      var w=money(before);
      if(was.textContent!==w)was.textContent=w;
    }else if(was){was.remove();}
  }

  function tick(){
    var drawer=document.getElementById('mzc-drawer');
    if(!drawer)return;
    if(busy){again=true;return;}
    busy=true;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var s=signature(cart);
      if(s===lastSig && decorationEnPlace())return;   /* rien a faire */
      if(s!==lastSig) filets=0;
      lastSig=s;
      /* On NE deconnecte PAS l'observateur : entre un disconnect() et un
         observe() differe, les mutations venues des AUTRES scripts sont perdues
         — et c'est exactement ce qui arrivait quand z-paniermasazen refaisait
         body.innerHTML pendant cette fenetre : le tiroir restait sans prix.
         takeRecords() fait ce qu'il faut : il vide la file des mutations que
         NOUS venons de provoquer, sans jamais cesser d'ecouter les autres. */
      try{ fixMoney(); appliquer(drawer,cart); }catch(e){}
      if(obs)obs.takeRecords();
      /* Filet : si le tiroir a ete reconstruit juste apres notre passe, on
         repare une fois, sans boucler (lastSig force un vrai recalcul). */
      /* 03/09 — au plus 2 reprises par changement de panier, jamais en boucle. */
      if(filets<2){ filets++; setTimeout(function(){ if(!decorationEnPlace()){ lastSig=''; run(); } },400); }
    }).catch(function(){}).then(function(){
      busy=false;
      if(again){again=false;run();}
    });
  }

  var t=null;
  function run(){if(t)clearTimeout(t);t=setTimeout(tick,70);}
  function forcer(){lastSig='';run();}

  /* 02/09 — DECORATION IMMEDIATE, SANS ATTENDRE NI RE-TELECHARGER.
     z-paniermasazen vient de peindre le tiroir et tient deja l'objet panier a
     jour : il nous appelle ici, dans la meme passe. Avant, on attendait 70 ms
     puis on refaisait un fetch('/cart.js') : le prix et « Economisez » etaient
     donc ecrits une premiere fois par la section, puis une seconde fois par nous
     0,6 s plus tard — vu par Lancelot comme « ca saute 2 fois ». On note aussi
     l'empreinte du panier, pour que la minuterie qui suit n'ait plus rien a faire. */
  window.__almDecorerPanier = function(cart){
    var drawer=document.getElementById('mzc-drawer');
    if(!drawer||!cart)return;
    if(t){clearTimeout(t);t=null;}
    try{ lastSig=signature(cart); fixMoney(); appliquer(drawer,cart); }catch(e){}
    if(obs)obs.takeRecords();
  };

  /* ══════════════════════════════════════════════════════════════════════════
     2026-08-25 — UN SEUL CHEMIN D'OUVERTURE DU TIROIR.
     Le clic sur l'icone panier du header etait traite DEUX FOIS :
       1. par un ecouteur pose sur le lien lui-meme (sections/z-header-masazen,
          ~ligne 5182) qui ouvre le tiroir INSTANTANEMENT, avec le contenu deja
          construit et decore au chargement de la page — c'est le bon chemin ;
       2. puis, parce que ce premier ecouteur ne coupe pas la propagation, par un
          ecouteur delegue sur document (sections/z-paniermasazen, ~ligne 1174)
          qui refait fetch('/cart.js') + un fetch par article, puis ecrase tout
          avec body.innerHTML — ce qui rase la decoration et declenche la cascade
          des six observateurs.
     Mesure avant correctif : le contenu du tiroir passait de 815 a 700
     caracteres a l'ouverture et ne revenait a l'etat correct qu'a 3,4 s.
     ON COUPE DONC LA PROPAGATION apres le premier ecouteur : le tiroir s'ouvre
     avec le contenu deja pret, et on se contente de rafraichir prix et bouton
     via forcer() — un seul /cart.js, aucune reconstruction du DOM.
     FILET DE SECURITE : si le tiroir n'est pas ouvert juste apres (ordre des
     ecouteurs different de celui attendu), on l'ouvre nous-memes. Et s'il
     n'existe pas du tout, on ne touche a rien : le lien /cart fonctionne
     normalement.
     POUR ANNULER : supprimer verrouillerOuverture() et son appel dans boot().
     ══════════════════════════════════════════════════════════════════════════ */
  function verrouillerOuverture(){
    var liens=document.querySelectorAll('a[href="/cart"], a[href^="/cart?"], .mz-action--cart');
    Array.prototype.forEach.call(liens,function(a){
      if(a.closest('#mzc-drawer'))return;
      if(a.__almOuvertureUnique)return;
      a.__almOuvertureUnique=1;
      a.addEventListener('click',function(e){
        var d=document.getElementById('mzc-drawer');
        if(!d)return;                 /* pas de tiroir : on laisse le lien /cart agir */
        e.preventDefault();
        e.stopPropagation();          /* <- empeche la reconstruction complete */
        if(!d.classList.contains('active')){
          d.classList.add('is-open','active','open');
          var ov=document.getElementById('mzc-overlay');
          if(ov)ov.classList.add('is-open','active','open');
          document.body.classList.add('mzc-open');
        }
        forcer();
      });
    });
  }

  function boot(){
    var d=document.getElementById('mzc-drawer');
    if(d){obs=new MutationObserver(run);obs.observe(d,{childList:true,subtree:true});}
    verrouillerOuverture();
    run();
    ['cart:updated','cart:refresh','cart:change','cart:add','on:cart:update'].forEach(function(ev){document.addEventListener(ev,forcer);});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
